// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"377":"8dfccda7","586":"9b65967a","900":"e9d7b358"}[chunkId] + ".chunk.css";
};